export const MIDIControlEventNames = [
  "Bank Select", // CC0
  "Modulation",
  "Breath Controller",
  "Undefined",
  "Foot Pedal",
  "Portamento Time",
  "Data Entry",
  "Volume",
  "Undefined",
  "Balance",
  "Pan", // CC10
  "Expression",
  "Effect Control 1",
  "Effect Control 2",
  "Undefined",
  "Undefined",
  "Ribbon Controller or General Purpose Slider 1",
  "Knob 1 or General Purpose Slider 2",
  "General Purpose Slider 3",
  "Knob 2 or General Purpose Slider 4",
  "Knob 3 or Undefined", // CC20
  "Knob 4 or Undefined",
  "Undefined",
  "Undefined",
  "Undefined",
  "Undefined",
  "Undefined",
  "Undefined",
  "Undefined",
  "Undefined",
  "Undefined", // CC30
  "Undefined",
  "Bank Select",
  "Modulation Wheel",
  "Breath controller",
  "Undefined",
  "Foot Pedal",
  "Portamento Time",
  "Data Entry",
  "Volume",
  "Balance", // CC40
  "Undefined",
  "Pan position",
  "Expression",
  "Effect Control 1",
  "Effect Control 2",
  "Undefined",
  "Undefined",
  "Undefined",
  "Undefined",
  "Undefined", // CC50
  "Undefined",
  "Undefined",
  "Undefined",
  "Undefined",
  "Undefined",
  "Undefined",
  "Undefined",
  "Undefined",
  "Undefined",
  "Undefined", // CC60
  "Undefined",
  "Undefined",
  "Undefined",
  "Hold Pedal",
  "Portamento",
  "Sustenuto Pedal",
  "Soft Pedal",
  "Legato Pedal",
  "Hold 2 Pedal",
  "Sound Variation", // CC70
  "Resonance",
  "Sound Release Time",
  "Sound Attack Time",
  "Frequency Cutoff",
  "Sound Control 6",
  "Sound Control 7",
  "Sound Control 8",
  "Sound Control 9",
  "Sound Control 10",
  "Decay", // CC80
  "High Pass Filter Frequency",
  "General Purpose Button 3",
  "General Purpose Button 4",
  "Undefined",
  "Undefined",
  "Undefined",
  "Undefined",
  "Undefined",
  "Undefined",
  "Undefined", // CC90
  "Reverb Level",
  "Tremolo Level",
  "Chorus Level",
  "Detune",
  "Phaser Level",
  "Data Button Increment",
  "Data Button Decrement",
  "NRPN (LSB)",
  "NRPN (MSB)",
  "RPN (LSB)", // CC100
  "RPN (MSB)",
  "Undefined",
  "Undefined",
  "Undefined",
  "Undefined",
  "Undefined",
  "Undefined",
  "Undefined",
  "Undefined",
  "Undefined", // CC110
  "Undefined",
  "Undefined",
  "Undefined",
  "Undefined",
  "Undefined",
  "Undefined",
  "Undefined",
  "Undefined",
  "Undefined",
  "All Sound Off", // CC120
  "All Controllers Off",
  "Local Keyboard",
  "All Notes Off",
  "Omni Mode Off",
  "Omni Mode On",
  "Mono Operation",
  "Poly Operation", // CC127
] as const
